import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filter'
})
export class FilterPipe implements PipeTransform {
	transform(items: any[], searchText: string): any[] {
		if (!items) {return [];}
		if (!searchText) {return items;}

		return items.filter(item => {
			return Object.keys(item).some(key => {
				return String(item[key]).toLowerCase().includes(searchText.toLowerCase());
			});
		});
	}
}


/**
 * Pipe - convertJsonDate
 *
 * erwartet ein Datum der Form 000-00-00 (YYYY-MM--DD). Das Format wird mittels
 * Regular Expression geprüft. Ist das Format korrekt, wird das datum umgewandelt
 * in das Format 00.00.0000 (DD.MM.YYYY). Andernfalls wird das übergebene Datum
 * wieder zurückgegeben.
 */
@Pipe({
	name: 'convertJsonDate'
})
export class ConvertJsonDatePipe implements PipeTransform {
	transform(value: string, ...args) {

		if (!value) {
			return '';
		}

		const regex = /^\d{4}-\d{2}-\d{2}$/g;
		if (value.match(regex)) {
			// input YYYY-DD-MM
			const pieces = value.split('-');
			// output DD.MM.YYYY
			return pieces[2] + '.' + pieces[1] + '.' + pieces[0];
		} else {
			return value;
		}

	}
}
